import { Link } from 'react-router-dom';
import { sportsCategories } from '@/mocks/common';

export default function CategorySection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <span className="text-primary-600 text-sm font-semibold tracking-wide">赛事分类</span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-2">
              全部体育项目
            </h2>
            <p className="text-foreground-500 text-sm mt-2 max-w-md mx-auto">
              覆盖全球50+体育项目，每日数千场比赛任您选择
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
            {sportsCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group bg-background-50 border border-background-200 rounded-lg p-5 md:p-6 text-center hover:border-primary-300 transition-all duration-200 cursor-pointer"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-200">
                  <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                </div>
                <h3 className="font-semibold text-foreground-900 text-sm md:text-base mb-1 whitespace-nowrap">{cat.name}</h3>
                <p className="text-xs text-foreground-400">{cat.matchCount}+ 赛事</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}